import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
const tableOption = function (that) {
  return {
    page: true,
    selection: false,
    index: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    // calcHeight: 100,
    menuWidth: 200,
    labelSuffix: " ：",
    labelWidth: "100",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: "955px",
    emptyText: "暂无数据",
    column: [
      {
        label: "巡更任务名称",
        prop: "taskName",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        search: true,
        searchSlot: true,
        overHidden: true,
        align: "center",
        searchPlaceholder: "请选择任务名称",
        minRows: 4,
        maxlength: 50,
        span: 12
      },
      {
        label: "任务状态",
        type: "select",
        prop: "taskStatus",
        // hide: true,
        search: true,
        dicData: [
          {
            label: "待巡逻",
            value: 1
          },
          {
            label: "巡逻中",
            value: 2
          },
          {
            label: "已完成",
            value: 3
          },
          {
            label: "已超时",
            value: 4
          }
        ],
        formatter: function (row, value) {
          if (value == 1) {
            return "待巡逻";
          }
          if (value == 2) {
            return "巡逻中";
          }
          if (value == 3) {
            return "已完成";
          }
          if (value == 4) {
            return "已超时";
          }
        },
        span: 12
      },

      {
        label: "计划开始时间",
        prop: "taskStartTime",
        type: "datetime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        valueFormat: "timestamp",
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      },
      {
        label: "计划结束时间",
        prop: "taskEndTime",
        type: "datetime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        valueFormat: "timestamp",
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      },
      {
        label: "实际开始时间",
        prop: "realStartTime",
        type: "datetime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        valueFormat: "timestamp",
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      },
      {
        label: "实际结束时间",
        prop: "realEndTime",
        type: "datetime",
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: false,
        // format: 'yyyy-MM-dd hh:mm:ss',
        valueFormat: "timestamp",
        span: 12,
        align: "center",
        formatter: function (row, value) {
          return value
            ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
            : "";
        }
      },
      {
        label: "巡逻员",
        prop: "executorNames",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        search: true,
        overHidden: true,
        align: "center",
        span: 12
      },
      {
        label: "隶属中队",
        prop: "securityWorkGroupNames",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        search: true,
        overHidden: true,
        align: "center",
        span: 12,
        searchSlot: true
      },
      {
        label: "巡更日期",
        prop: "patrolDate",
        // type: 'daterange',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        search: true,
        hide: true,
        searchSlot: true,
        valueFormat: "timestamp",
        span: 12,
        align: "center",
        formslot: true
      },
      {
        label: "打卡进度",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        // search: true,
        overHidden: true,
        align: "center",
        span: 12,
        formatter: function (row, value) {
          return row.clockPointNum + "/" + row.totalPoint;
        }
      },
      {
        label: "是否发现异常",
        prop: "alarmCount",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        // search: true,
        overHidden: true,
        align: "center",
        span: 12,
        formatter: function (row, value) {
          return row.alarmCount >= 1 ? "是" : "否";
        }
      },
      {
        label: "姓名",
        prop: "reportPerson",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        search: false,
        hide: true,
        overHidden: true,
        align: "center",
        searchPlaceholder: "请输入姓名",
        minRows: 4,
        maxlength: 50,
        span: 12,
        rules: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur"
          }
        ]
      }
    ]
  };
};
export default tableOption;
